  const ProdCollections = {
    s1: {
        tops: {
            title: 'Los Angeles Pull On Pink Bikini Top',
            handle: 'los-angeles-top',
        },
        bottoms: {
            title: 'Los Angeles Low Coverage Pink Bikini Bottom',
            handle: 'los-angeles-bottom',
        }
    },
    s2: {  
        tops: {
            title: 'Aaliyah Hand Beaded Black Bikini Top',
            handle: 'copy-of-aaliyah-bikini-top-black',
        },
        bottoms: {
            title: 'Aaliyah Hand Embroidered Black Bikini Bottom',
            handle: 'aaliyah-bikini-bottoms-black',
        }
    },
     s3: {
        tops: {
            title: 'Rose Luxe Self-Tie Pink Bikini Top',
            handle: 'rose-bikini-top',
        },
        bottoms: {
            title: 'Rose Flattering Vintage Pink Bikini Bottoms',
            handle: 'rose-bikini-bottoms',
        }
    },
     s4: {
        tops: {
            title: 'Talia Hand Embroidered White Base Bikini Top',
            handle: 'talia-bikini-top',
        },
        bottoms: {
            title: 'Talia Classic Triangle White Base Bikini Bottoms',
            handle: 'talia-bikini-bottoms',
        }
    },
     s5: {
        tops: {
            title: 'Ophelia Hand Embroidered Summer Bikini Top Pink',
            handle: 'ophelia-bikini-pink-1',
        },
        bottoms: {
            title: 'Ophelia Crystal Summer Bikini Bottoms Pink',
            handle: 'ophelia-bikini-bottoms-pink',
        }
    },
     s6: {
        tops: {
            title: 'Aaliyah Hand Beaded White Bikini Top',
            handle: 'aaliyah-bikini-top-white',
        },
        bottoms: {
            title: 'Aaliyah Hand Embroidered White Bikini Bottom',
            handle: 'aaliyah-bikini-bottom-white',
        }
    },
     s7: {
        tops: {
            title: 'Quinn Clasp Closure Blue Bikini Top',
            handle: 'quinn-bikini-top-blue',
        },
        bottoms: {
            title: 'Quinn Embellished Slip On Blue Bikini Bottoms',
            handle: 'quinn-bikini-bottoms-blue',
        }
    },
     s8: {
        tops: {
            title: 'Clover Embellished Tropical Embroidery Bikini Top',
            handle: 'clover-bikini-top',
        },
        bottoms: {
            title: 'Clover Self-Tie Side Luxe Bikini Bottoms',
            handle: 'clover-bikini-bottoms',
        }
    },
    s9: {
        tops: {
            title: 'Marissa Hand Embroidered Black Luxe Bikini Top',
            handle: 'marissa-hand-embroidered-black-luxe-bikini',
        },
        bottoms: {
            title: 'Marissa Hand Embroidered Black Luxe Bikini Bottom',
            handle: 'marissa-hand-embroidered-black-luxe-bikini-bottoms',
        }
    },
    s10: {
        tops: {
            title: 'Ophelia Hand Embroidered Summer Bikini Top White',
            handle: 'ophelia-bikini-top-white',
        },
        bottoms: {
            title: 'Ophelia Hand Embroidered Summer Bikini Bottoms White',
            handle: 'ophelia-bikini-bottoms-white',
        }
    },
    s11: {
        tops: {
            title: 'Emma Jane Self-Tie Pink Bikini Top',
            handle: 'emma-jane-top',
        },
        bottoms: {
            title: 'Emma Jane Slip On Pink Bikini Bottom',
            handle: 'emma-jane-bottom',
        }
    },
    s12: {
        tops: {
            title: 'Hester Underwire Self Tie Multi-Coloured Bikini Top',
            handle: 'hester-bikini-top',
        },
        bottoms: {
            title: 'Hester Slip On Multi-Coloured Bikini Bottoms',
            handle: 'hester-bikini-bottoms',
        }
    },
    s13: {
        tops: {
            title: 'Ophelia Bikini Black Top',
            handle: 'ophelia-bikini-black-top',
        },
        bottoms: {
            title: 'Ophelia Bikini Black Bottoms',
            handle: 'copy-of-ophelia-bikini-black-top',
        }
    },
    s14: {
        tops: {
            title: 'Quinn Clasp Closure Lilac Bikini Top',
            handle: 'quinn-bikini-top',
        },
        bottoms: {
            title: 'Quinn Embellished Slip On Lilac Bikini Bottoms',
            handle: 'quinn-bikini-bottoms',
        }
    },
     s15: {
        tops: {
            title: 'Sienna Sequin Embroidery Bikini Top',
            handle: 'sienna-bikini-top',
        },
        bottoms: {
            title: 'Sienna Sequin Embroidery Bikini Bottoms',
            handle: 'sienna-bikini-bottoms',
        }
    },
    s16: {
        tops: {
            title: 'Calliope Luxury Crystal White Bikini Top',
            handle: 'calliope-bikini-top',
        },
        bottoms: {
            title: 'Calliope Luxury Crystal White Bikini Bottom',
            handle: 'calliope-luxury-crystal-white-bikini-bottom',
        }
    },
    s17: {
        tops: {
            title: 'Ursula Bikini TOP Light Pink',
            handle: 'copy-of-ursula-bikini-light-pink-veivet',
        },
        bottoms: {
            title: 'Ursula Bikini BOTTOMS Light Pink',
            handle: 'ursula-bikini-bottoms-light-pink-velvet',
        }
    },
    s18: {
        tops: {
            title: 'New York Hand-Embroidered Black Top',
            handle: 'new-york-top',
        },
        bottoms: {
            title: 'New York Hand-Embroidered Black Skirt',
            handle: 'new-york-skirt',
        }
    },
    s19: {
        tops: {
            title: 'Santa Monica Hand-Embroidered Party Top',
            handle: 'santa-monica-top',
        },
        bottoms: {
            title: 'Venice Hand-Embroidered Party Skirt',
            handle: 'venice-skirt',
        }
    },
    s20: {
        tops: {
            title: 'Tallulah Crystal Co-Ord Pull On Top',
            handle: 'tallulah-co-ord',
        },
        bottoms: {
            title: 'Tallulah Crystal Co-Ord Mini Skirt',
            handle: 'tallulah-co-ord-skirt',
        }
    },
    s21: {
        tops: {
            title: 'Callie Co-ord One Shoulder Top Pink',
            handle: 'callie-co-ord-pink-top',
        },
        bottoms: {
            title: 'Callie Co-ord Luxe Mini Skirt Pink',
            handle: 'callie-co-ord-skirt-pink',
        }
    },
    s22: {
        tops: {
            title: 'Monty Co-ord Hand Embroidered Bead Pink Top',
            handle: 'monty-co-ord',
        },
        bottoms: {
            title: 'Monty Co-ord Hand Embroidered Bead Pink Skirt',
            handle: 'monty-co-ord-skirt',
        }
    },
    s23: {
        tops: {
            title: 'Melodie Co-ord Hand Embroidered Crystal Peach Top',
            handle: 'summer-bikini-melodie-co-ord-peach-top',
        },
        bottoms: {
            title: 'Melodie Co-ord Hand Embroidered Crystal Peach Skirt',
            handle: 'melodie-co-ord-peach-skirt',
        }
    },
    s24: {
        tops: {
            title: 'Calliope Luxury Crystal Nude Co-Ord Top',
            handle: 'calliope-co-ord-top',
        },
        bottoms: {
            title: 'Calliope Luxury Crystal Nude Co-Ord Skirt',
            handle: 'calliope-co-ord-skirt',
        }
    },
     s25: {
        tops: {
            title: 'Monni Co-ord Hand Embroidered Crystal Purple Top',
            handle: 'mei-co-ord-purple',
        },
        bottoms: {
            title: 'Monni Co-ord Hand Embroidered Crystal Purple Skirt',
            handle: 'monni-co-ord-skirt',
        }
    },
     s26: {
        tops: {
            title: 'Fia Tropical Hand Embroidered Bikini Top Lilac',
            handle: 'fia-bikini-pink',
        },
        bottoms: {
            title: 'Fia Tropical Hand Embroidered Bikini Bottoms Lilac',
            handle: 'fia-bikini-bottoms-pink',
        }
    },
     s27: {
        tops: {
            title: 'Callie Co-ord One Shoulder White Top',
            handle: 'callie-co-ord-top-white',
        },
        bottoms: {
            title: 'Callie Co-ord Luxe Mini Skirt White',
            handle: 'callie-co-ord-skirt',
        }
    },
     s28: {
        tops: {
            title: 'Marie Co-Ord White Top',
            handle: 'marie-co-ord-top',
        },
        bottoms: {
            title: 'Marie Hand Beaded Premium Co-Ord Pink Mini Skirt',
            handle: 'marie-co-ord-skirt',
        }
    },
     s29: {
        tops: {
            title: 'Callie Co-ord One Shoulder Black Top',
            handle: 'callie-co-ord-top-black',
        },
        bottoms: {
            title: 'Callie Co-ord Luxe Mini Skirt Black',
            handle: 'callie-co-ord-skirt-black',
        }
    },
     s30: {
        tops: {
            title: 'Violet Halter Hand Embroidered Plum Bikini Top',
            handle: 'violet-bikini-top',
        },
        bottoms: {
            title: 'Violet Hand Embroidered Plum Bikini Bottoms',
            handle: 'violet-bikini',
        }
    },
     s31: {
        tops: {
            title: 'Callie Co-ord Fuschia One Shoulder Top',
            handle: 'callie-co-ord-fuschia-top',
        },
        bottoms: {
            title: 'Callie Co-ord Fuschia Mini Skirt',
            handle: 'callie-co-ord-fuschia-skirt',
        }
    },
    s32: {
        tops: {
            title: 'Cynthia Cupped Textured Glitter Bikini Top',
            handle: 'cynthia-bikini',
        },
        bottoms: {
            title: 'Cynthia Self Tie Bikini Bottoms',
            handle: 'cynthia-bikini-bottoms',
        }
    },
     s33: {
        tops: {
            title: 'Angelica Self-Tie Lilac Bandeau Bikini Top',
            handle: 'angelica-bandeau-top',
        },
        bottoms: {
            title: 'Georgia High Rise Lilac Bikini Bottom',
            handle: 'georgia-bottom',
        }
    },
    s34: {
        tops: {
            title: 'Brielle Triangle Multi-Coloured Bikini Top',
            handle: 'brielle-triangle-multi-coloured-bikini-top',
        },
        bottoms: {
            title: 'Brielle Low Rise Multi-Coloured Bikini Bottoms',
            handle: 'brielle-low-rise-multi-coloured-bikini-bottoms',
        }
    },
    s35: {
        tops: {
            title: 'Amal Green Bikini Top',
            handle: 'amal-bikini-top',
        },
        bottoms: {
            title: 'Amal Green Bikini Bottoms',
            handle: 'amal-green-bikini-bottoms',
        }
    },
    s36: {
        tops: {
            title: 'Milly Rose Blue Printed Bikini Top',
            handle: 'milly-rose-embroidered-luxe-bikini-top',
        },
        bottoms: {
            title: 'Milly Rose Blue Printed Bikini Bottom',
            handle: 'milly-rose-blue-printed-bikini-bottom',
        }
    },
    s37: {
        tops: {
            title: 'Michelle Hand Beaded Yellow Bikini Top',
            handle: 'michelle-hand-beaded-yellow-bikini',
        },
        bottoms: {
            title: 'Michelle Hand Beaded Yellow Bikini Bottom',
            handle: 'michelle-hand-beaded-yellow-bikini-bottoms',
        }
    },
    s38: {
        tops: {
            title: 'Nixie Triangle Shape Yellow Bikini Top',
            handle: 'nixie-bikini-top',
        },
        bottoms: {
            title: 'Nixie Tropical Low Coverage Pink Bikini Bottoms',
            handle: 'nixie-bikini-bottoms',
        }
    },
      s39: {
        tops: {
            title: 'Ariel Hand-Beaded Red Bikini Top',
            handle: 'ariel-hand-beaded-red-bikini-top',
        },
        bottoms: {
            title: 'Ariel Hand-Beaded Red Bikini Bottoms',
            handle: 'ariel-hand-beaded-red-bikini-bottoms',
        }
    },
      s40: {
        tops: {
            title: 'Rose Ellie Multi-Coloured Bikini Top',
            handle: 'rose-ellie-bikini-top',
        },
        bottoms: {
            title: 'Rose Ellie Multi-Coloured Bikini Bottoms',
            handle: 'rose-ellie-multi-coloured-bikini-bottoms',
        }
    },
      s41: {
        tops: {
            title: 'Pamela Plum Hand-Beaded Bikini Top',
            handle: 'pamela-plum-bikini-top',
        },
        bottoms: {
            title: 'Pamela Plum Hand-Beaded Bikini Bottoms',
            handle: 'pamela-plum-hand-beaded-bikini-bottoms',
        }
    },
     s42: {
        tops: {
            title: 'Pandora Multi-Coloured Crochet V-Neck Top',
            handle: 'pandora-top',
        },
        bottoms: {
            title: 'Pandora Multi-Coloured Crochet Party Bottom',
            handle: 'pandora-bottom',
        }
    },
     s43: {
        tops: {
            title: 'Amel Bikini Top',
            handle: 'amel-bikini-top',
        },
        bottoms: {
            title: 'Amel Bikini Bottoms',
            handle: 'amel-bikini-bottoms',
        }
    },
     s44: {
        tops: {
            title: 'Los Angeles Pull On  Bikini Top',
            handle: 'los-angeles-top',
        },
        bottoms: {
            title: 'Los Angeles Low Coverage  Bikini Bottom',
            handle: 'los-angeles-bottom',
        }
    },
    s45: {
        tops: {
            title: 'Mish Self-Tie Bikini Top',
            handle: 'mish-bikini-top',
        },
        bottoms: {
            title: 'Mish High Rise Bikini Bottoms',
            handle: 'mish-high-rise-bikini-bottoms',
        }
    },
    s46: {
        tops: {
            title: 'Fia Tropical Hand Embroidered Bikini Top Blue',
            handle: 'fia-bikini-blue-top',
        },
        bottoms: {
            title: 'Fia Tropical Hand Embroidered Bikini Bottoms Blue',
            handle: 'fia-tropical-hand-embroidered-bikini-bottoms-blue',
        }
    },  
     s47: {
        tops: {
            title: 'Mulata Hand-Beaded Bikini Top',
            handle: 'mulata-hand-beaded-bikini-top',
        },
        bottoms: {
            title: 'Mulata Hand-Beaded Bikini Bottom',
            handle: 'mulata-hand-beaded-bikini-bottom',
        }
    },  
     s48: {
        tops: {
            title: 'Danielle Whitney Hand-Beaded Bikini Top',
            handle: 'danielle-whitney-top',
        },
        bottoms: {
            title: 'Danielle Whitney Hand-Beaded Bikini Bottom',
            handle: 'danielle-whitney-bottom',
        }
    },
     s49: {
        tops: {
            title: 'Elizabetha Hand-Beaded Bikini Top',
            handle: 'elizabetha-hand-beaded-bikini-top',
        },
        bottoms: {
            title: 'Elizabetha Hand-Beaded Bikini Bottom',
            handle: 'elizabetha-hand-beaded-bikini-bottom',
        }
    },
     s50: {
        tops: {
            title: 'Violeta Hand-Beaded Bikini Top',
            handle: 'violeta-hand-beaded-bikini-top',
        },
        bottoms: {
            title: 'Violeta Hand-Beaded Bikini Bottom',
            handle: 'violeta-hand-beaded-bikini-bottom',
        }
    },
     s51: {
        tops: {
            title: 'Dosila Hand-Beaded Bikini Top',
            handle: 'dosila-hand-beaded-bikini-top',
        },
        bottoms: {
            title: 'Dosila Hand-Beaded Bikini Bottom',
            handle: 'dosila-hand-beaded-bikini-bottom',
        }
    },
     s52: {
        tops: {
            title: 'Vegas Beaded Mini Blue Party Beach Co-ord Top',
            handle: 'vegas-beaded-mini-blue-party-beach-co-ord-top',
        },
        bottoms: {
            title: 'Vegas Beaded Mini Blue Party Beach Co-ord Skirt',
            handle: 'vegas-co-ord-blue-skirt',
        }
    },
    s53: {
        tops: {
            title: 'Lara Crystal Bikini Top Lilac',
            handle: 'lara-crystal-bikini-top-blue',
        },
        bottoms: {
            title: 'Lara Crystal Bikini Bottom Blue',
            handle: 'lara-crystal-bikini-bottom-blue',
        }
    },
      s54: {
        tops: {
            title: 'Calliope Luxury Crystal Cobalt Bikini Top',
            handle: 'calliope-luxury-crystal-cobalt-bikini-top',
        },
        bottoms: {
            title: 'Calliope Luxury Crystal Bikini Bottom White',
            handle: 'calliope-luxury-crystal-white-bikini-bottom',
        }
    },
    s55: {
        tops: {
            title: "Mia's Marina Bikini Top",
            handle: 'mias-marina-bikini-white-pink-top',
        },
        bottoms: {
            title: "Mia's Marina Bikini Bottom",
            handle: 'mias-marina-bikini-white-pink-bottom',
        }
    },
    s56: {
        tops: {
           title: "Aphrodite's White Beaded Co-ord Top – Daphne x Oceanus",
           handle: 'daphne-beaded-white-co-ord-set-top',
        },
        bottoms: {
            title: "Aphrodite's White Beaded Co-ord Skirt - Daphne x Oceanus",
            handle: 'beaded-white-co-ord-set-skirt',
        }
    },
     s57: {
        tops: {
           title: "Nyx Black Beaded Co-ord top – Daphne x Oceanus",
           handle: 'nyx-black-beaded-co-ord-top-daphne-collection-copy',
        },
        bottoms: {
            title: "Nyx Black Beaded Co-ord Trousers – Daphne x Oceanus",
            handle: 'nyx-black-beaded-co-ord-bottom-daphne-collection',
        }
    },
     s58: {
        tops: {
           title: "Thalia Rose Co-ord Top - Daphne x Oceanus",
           handle: 'thalia-rose-co-ord-top-daphne-collection',
        },
        bottoms: {
            title: "Thalia Rose Co-ord Trousers - Daphne x Oceanus",
            handle: 'thalia-rose-co-ord-duplicate-daphne-collection',
        }
    },
     s59: {
        tops: {
           title: "Faith Beaded Powermesh Jellyfish Top",
           handle: 'beaded-powermesh-green-top',
        },
        bottoms: {
            title: "Hazel Beaded Lilac Powermesh Jellyfish Maxi Skirt",
            handle: 'hazel-beaded-skirt-1',
        }
    },
};

  const NewCollections = {
       s1: {
        tops: {
            title: 'Boston Vibrant Hand-Beaded Dress',
            handle: 'boston-dress',
        },
        bottoms: {
            title: 'Talia Hand Beaded Multi-Coloured Crystal Party Dress',
            handle: 'talia-dress',
        }
    },
    s2: {  
        tops: {
            title: 'Calliope Luxury Crystal Maxi Party Dress White',
            handle: 'calliope-dress-white',
        },
        bottoms: {
            title: 'Pandora Luxe Hand Beaded dress Baby Blue',
            handle: 'pandora-dress',
        }
    }
  }
  

function handleDataCartOpenMutation(mutationsList, observer) {
   const formmDiv = document.getElementById("form1");
    const formDiv = document.getElementById("form2");
    for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-open') {
            if (mutation.target.getAttribute('data-cart-open') === 'true') {
                if (formmDiv.querySelector("form") === null && formDiv.querySelector("form") === null) {
            fetchCartItems();
        }
            }
        }
    }
}


const oscSection = document.getElementById("osc-section");

const config = { attributes: true, attributeFilter: ['data-cart-open'] };

const observer = new MutationObserver(handleDataCartOpenMutation);

observer.observe(oscSection, config);

       function sendCartMessageToSlack(productTitle) {
        var slackWebhookUrl = "https://hooks.slack.com/services/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";
        var payload = {
          text: "Item Added From Best Sellers we Recommend: " + productTitle
        };
      
        fetch(slackWebhookUrl, {
          method: "POST",
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          if (!response.ok) {
            throw new Error("Failed to send message to Slack");
          }
        })
        .catch(function(error) {
          console.error("Error:", error);
        });
      }

    
    function createAddToCartForm(elementId, product) {
        var addToCartForm = document.getElementById(elementId);
                   
        if (!addToCartForm) {
            console.error("Element with ID '" + elementId + "' not found.");
            return;
        }

        var form = document.createElement('form');
        form.className = 'suggested__product--form';
        form.style.flexDirection = 'row';
        form.style.gap = '1rem';
        form.style.minWidth = '270px';
        form.style.alignItems = 'center';
        form.style.justifyContent = 'flex-start';
        form.method = 'post';
        form.action = '/cart/add';

        var ImgContainer = document.createElement('a');
        ImgContainer.href = product.url;
        ImgContainer.className= 'bs__image-container';
        ImgContainer.style.overflow= 'hidden';
        ImgContainer.style.height= '110px';
        ImgContainer.style.width= '100px';
      
        var imageTag = document.createElement('img');
        imageTag.src = product.featured_image;
        imageTag.alt = product.title;
        imageTag.style.objectFit = 'cover';
        imageTag.style.height = '100%';
        imageTag.style.width = '100%';
        imageTag.style.position = 'relative';
        ImgContainer.appendChild(imageTag);
        form.appendChild(ImgContainer);

      
        if (product && product.variants && product.variants.length > 0) {
            var productIdInput = document.createElement('input');
            productIdInput.type = 'hidden';
            productIdInput.name = 'id';
            productIdInput.value = product.variants[0].id;
            form.appendChild(productIdInput);

            var quantityInput = document.createElement('input');
            quantityInput.type = 'hidden';
            quantityInput.id = 'quantity';
            quantityInput.name = 'quantity';
            quantityInput.value = '1';
            form.appendChild(quantityInput);

           var infoContainer = document.createElement('div');
           infoContainer.className = 'bs__infoContainer';
           infoContainer.style.display = 'flex';
           infoContainer.style.flexDirection = 'column';
           infoContainer.style.gap = '0.91rem';
           infoContainer.style.fontSize = '1rem';

            var name = document.createElement('a');
            name.href = product.url;
            name.style.color = 'black';
            name.style.fontSize = '10.5pt';
            name.innerText = product.title;
            infoContainer.appendChild(name);

            var price = document.createElement('div');
            price.classList.add('ProductMeta__Price'); 
            price.style.fontSize = '9.5pt';
            var formattedPrice = formatMoney(product.price, format);
            // console.log(formattedPrice)
            var textNode = document.createTextNode(formattedPrice);
            price.appendChild(textNode);
            infoContainer.appendChild(price);
           
            var containerBottom = document.createElement('div');
            containerBottom.style.display = 'flex';
            containerBottom.style.gap = '0.5rem';

            var sizeContainer = document.createElement('div');
            sizeContainer.style.display = 'flex';
            sizeContainer.style.alignItems = 'center';
            sizeContainer.style.border = '1px solid #E1E1DA';

            var size = document.createElement('span');
            size.innerHTML = 'Size';
            size.style.fontSize = '9.5pt';
            size.style.padding = '6px';
            sizeContainer.appendChild(size);
          
            var select = document.createElement('select');
            select.className = 'bs__select';
            select.name = 'id';
            select.style.border = '0';
            select.style.maxWidth = '42px';
            select.style.backgroundColor = 'white';
            product.variants.forEach(function(variant) {
                var option = document.createElement('option');
                option.className = 'bs__option';
                option.style.fontSize = '9.5pt';
                option.value = variant.id;
                option.textContent = variant.title;
                select.appendChild(option);
            });
            sizeContainer.appendChild(select);
          
            containerBottom.appendChild(sizeContainer);

            var submitButton = document.createElement('input');
            submitButton.type = 'submit';
            submitButton.className = 'bs__buttonClass';
            submitButton.style.background = '#ff8fbd';
            submitButton.style.border = 'none';
            submitButton.style.fontSize = '9.5pt';
            submitButton.style.padding = '2px 27px';
            submitButton.style.fontFamily = 'Century Gothic';
            submitButton.value = 'Add';
            containerBottom.appendChild(submitButton);

            infoContainer.appendChild(containerBottom);
            form.appendChild(infoContainer);
          
            addToCartForm.appendChild(form);
        } else {
            console.error("Product or its variants not found.");
        }
        
            form.addEventListener('submit', function(event) {
            sendCartMessageToSlack(product.title);
          });
    }

    function fetchProduct(productHandle, elementId) {
        fetch(`/products/${productHandle}.js`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(product => {
                createAddToCartForm(elementId, product);
            })
            .catch(error => {
                console.error('Error fetching product:', error);
            });
    }

 function fetchCartItems() {
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(cartdata => {
        const keys = Object.keys(ProdCollections);
        const newKeys = Object.keys(NewCollections);

        const randomKeyIndex = Math.floor(Math.random() * keys.length); 
        const randomKey = keys[randomKeyIndex];
        const top = ProdCollections[randomKey].tops;
        const bottom = ProdCollections[randomKey].bottoms;

        const newRandomKeyIndex = Math.floor(Math.random() * newKeys.length); 
        const newRandomKey = newKeys[newRandomKeyIndex];
        const newTop = NewCollections[newRandomKey].tops;
        const newBottom = NewCollections[newRandomKey].bottoms;

        let inCartBottoms = false;
        let inCartBikini = false;
        let inCartNewBottoms = false;
        let inCartNewBikini = false;
        let hardcodedTop = false;
        let hardcodedBottom = false;
        let currentAbove = '';
        let currentBelow = '';
        let currentNewAbove = '';
        let currentNewBelow = '';

        cartdata.items.forEach(item => {
            // Check ProdCollections
            for (const key in ProdCollections) {
                const collection = ProdCollections[key];
                const above = collection.tops;
                const below = collection.bottoms;

                if (item.handle === above.handle) {
                    inCartBikini = true;
                    currentAbove = below.handle;
                }

                if (item.handle === below.handle) {
                    inCartBottoms = true;
                    currentBelow = above.handle;
                }
            }

            // Check NewCollections
            for (const key in NewCollections) {
                const collection = NewCollections[key];
                const above = collection.tops;
                const below = collection.bottoms;

                if (item.handle === above.handle) {
                    inCartNewBikini = true;
                    currentNewAbove = below.handle;
                }

                if (item.handle === below.handle) {
                    inCartNewBottoms = true;
                    currentNewBelow = above.handle;
                }
            }

            // Check for hardcoded products for form1 and form2
            if (item.handle === 'aurelia-embroidered-luxury-black-mini-skirt') {
                hardcodedTop = true;
            }

            if (item.handle === 'elani-sarong-pink') {
                hardcodedBottom = true;
            }

            // Check for hardcoded products for form3 and form4
            if (item.handle === 'mulata-pink-makeup-bag') {
                hardcodedTop = true;
            }

            if (item.handle === 'miranda-makeup-bag') {
                hardcodedBottom = true;
            }
        });

        // Handle the logic for form1 and form2
        if (inCartBikini && inCartBottoms) {
            if (hardcodedTop && hardcodedBottom) {
                console.log('all added');
                const bsContainer = document.getElementById("best-sellers-container");
                bsContainer.style.display = 'none';
            }
            else if (hardcodedTop) {
                fetchProduct('elani-sarong-pink', 'form2');
            }
            else if (hardcodedBottom) {
                fetchProduct('aurelia-embroidered-luxury-black-mini-skirt', 'form1');
            } else {
                fetchProduct('aurelia-embroidered-luxury-black-mini-skirt', 'form1');
                fetchProduct('elani-sarong-pink', 'form2');
            }
        }
        else if (inCartBikini) {
            if (hardcodedTop && hardcodedBottom) {
                fetchProduct(currentAbove, 'form2');
            } 
            else if (hardcodedTop) {
                fetchProduct('elani-sarong-pink', 'form2');
                fetchProduct(currentAbove, 'form1');
            } else {
                fetchProduct('aurelia-embroidered-luxury-black-mini-skirt', 'form2');
                fetchProduct(currentAbove, 'form1');
            }
        } else if (inCartBottoms) {
            if (hardcodedTop && hardcodedBottom) {
                fetchProduct(currentBelow, 'form1');
            }
            else if (hardcodedBottom) {
                fetchProduct(currentBelow, 'form1');
                fetchProduct('aurelia-embroidered-luxury-black-mini-skirt', 'form2');
            } else {
                fetchProduct(currentBelow, 'form1');
                fetchProduct('elani-sarong-pink', 'form2');
            }
        } else {
            fetchProduct(top.handle, 'form1');
            fetchProduct(bottom.handle, 'form2');
        }

        // Handle the logic for form3 and form4 (NewCollections)
        if (inCartNewBikini && inCartNewBottoms) {
            if (hardcodedTop && hardcodedBottom) {
                console.log('all added');
                const bsContainer = document.getElementById("best-sellers-container");
                bsContainer.style.display = 'none';
            }
            else if (hardcodedTop) {
                fetchProduct('miranda-makeup-bag', 'form4');
            }
            else if (hardcodedBottom) {
                fetchProduct('mulata-pink-makeup-bag', 'form3');
            } else {
                fetchProduct('mulata-pink-makeup-bag', 'form3');
                fetchProduct('miranda-makeup-bag', 'form4');
            }
        }
        else if (inCartNewBikini) {
            if (hardcodedTop && hardcodedBottom) {
                fetchProduct(currentNewAbove, 'form4');
            } 
            else if (hardcodedTop) {
                fetchProduct('miranda-makeup-bag', 'form4');
                fetchProduct(currentNewAbove, 'form3');
            } else {
                fetchProduct('mulata-pink-makeup-bag', 'form4');
                fetchProduct(currentNewAbove, 'form3');
            }
        } else if (inCartNewBottoms) {
            if (hardcodedTop && hardcodedBottom) {
                fetchProduct(currentNewBelow, 'form3');
            }
            else if (hardcodedBottom) {
                fetchProduct(currentNewBelow, 'form3');
                fetchProduct('mulata-pink-makeup-bag', 'form4');
            } else {
                fetchProduct(currentNewBelow, 'form3');
                fetchProduct('miranda-makeup-bag', 'form4');
            }
        } else {
            fetchProduct(newTop.handle, 'form3');
            fetchProduct(newBottom.handle, 'form4');
        }

    })
    .catch(error => console.error('Error:', error));
}


   